<template>
  <!-- <div class="tableHome" v-bind:style="{ 'background-image': 'url(' + this.tournImage + ')' }"> -->
  <div>
        <div class="above990">
            <vueper-slides autoplay :arrows="false" :pauseOnHover="false" :duration="6000" :infinite="false" :touchable="false">
                <!-- <vueper-slide>
                    <template #content>
                        <img class="Btours" :src="slideshow[0].desktop_image">
                        <div class="outerDiv">
                            <div class="innerDiv">
                                <h1 class="heading" :style="'color:' + slideshow[0].slide_heading_color">{{slideshow[0].slide_heading}}</h1>
                                <p class="line1" v-html="slideshow[0].slide_text_line_1"></p>
                                <p class="line2" v-html="slideshow[0].slide_text_line_2"></p>
                                <p class="line3" v-html="slideshow[0].slide_text_line_3"></p>
                            </div>
                        </div>
                    </template>
                </vueper-slide> -->
                <vueper-slide v-for="b in slideshow" :key="'bob' + b">
                    <template #content>
                        <img class="Btours" :src="b.desktop_image">
                        <div class="outerDiv">
                            <div class="innerDiv">
                                <h1 class="heading" :style="'color:' + b.slide_heading_color">{{b.slide_heading}}</h1>
                                <p class="line1" v-html="b.slide_text_line_1"></p>
                                <p class="line2" v-html="b.slide_text_line_2"></p>
                                <p class="lin3" v-html="b.slide_text_line_3"></p>
                            </div>
                        </div>
                    </template>
                </vueper-slide>
                <vueper-slide>
                    <template #content>
                        <div class=" active tableHome" v-bind:style="{ 'background-image': 'url(' + backImage + ')' }">
                        </div>
                    </template>
                </vueper-slide>

            </vueper-slides>
            <div id="myCarousel" class="carousel slide" data-ride="carousel" style="display:none">
            <ol class="carousel-indicators">
                <li data-target="#myCarousel" data-slide-to="0" class="active"></li>
                <li data-target="#myCarousel" data-slide-to="1"></li>
            </ol>

            <div class="carousel-inner">
                <div class="item tours">
                <div class="tableHome" v-bind:style="{ 'background-image': 'url(' + tournImage + ')' }">
                    <b-container>
                    <b-row class="above1200">
                        <b-col>
                        <b-row class="SponsorLogoText">
                            <b-col>
                            <div class="classTournBtn">
                                <button class="tournButtonMain">
                                    Tier 1
                                </button>
                            </div>
                            <h1 class="TournName">{{TourName}}</h1>
                            <h1 class="TournCourseName">{{course_name}}</h1>
                            <template v-if="bkImage == null">
                                <b-link :to="'/schedule/' " class="allNewsLink">
                                <button class="Allbuttons">
                                See Full Schedule
                                </button>
                                </b-link>
                            </template>
                            <template v-else>
                                <b-link :to="'/tournament/' + courseCode + '/' + Year " class="allNewsLink">
                                <button class="Allbuttons">
                                See Tournament Feed
                                </button>
                                </b-link>
                            </template>
                            </b-col>
                        </b-row>
                        </b-col>
                        <b-col>

                        </b-col>
                    </b-row>
                    <b-row class="below1200">
                        <b-col lg="12">
                        <b-row class="SponsorLogoText">
                            <b-col>
                            <div class="dates">
                                <h2 class="TournDates">{{tournDates}}</h2>
                            </div>
                            <h1 class="TournName">{{TourName}}</h1>
                            <h1 class="TournCourseName">{{course_name}}</h1>
                            <template v-if="bkImage == null">
                                <b-link :to="'/schedule/'" class="allNewsLink">
                                <button class="Allbuttons">
                                See Full Schedule
                                </button>
                                </b-link>
                            </template>
                            <template v-else>
                                <b-link :to="'/tournament/' + courseCode + '/' + Year" class="allNewsLink">
                                <button class="Allbuttons">
                                See Tournament Feed
                                </button>
                                </b-link>
                            </template>
                            </b-col>
                        </b-row>
                        </b-col>
                        <b-col lg="12">
                        </b-col>
                    </b-row>
                    </b-container>
                    <b-row class="imagefilesPos">
                    <b-col class="imageSize" lg="" sm="6" v-for="(image, index) in imagefiles" :key="'e' + index" v-show="image.ad_lcc == 'N' && image.ad_file != ''" >
                        <b-link :href="image.ad_link" :title="image.ad_desc" target="_blank">
                        <div class="imagefileImage" v-bind:style="{ 'background-image': 'url(' + image.ad_file + ')' }"></div>
                        </b-link>
                    </b-col>
                    </b-row>
                </div>
                </div>
            </div>
            </div>
        </div>
        <div class="below990">
            <vueper-slides autoplay :arrows="false" :pauseOnHover="false" :duration="4000" :infinite="true" :touchable="true" :dragging-distance="50" >
                <!-- <vueper-slide>
                    <template #content>
                        <img class="Btours" :src="slideshow[0].mobile_image">
                        <div class="outerDiv">
                            <div class="innerDiv">
                                <h1 class="heading" :style="'color:' + slideshow[0].slide_heading_color">{{slideshow[0].slide_heading}}</h1>
                                <p class="line1" v-html="slideshow[0].slide_text_line_1_mobile"></p>
                                <p class="line2" v-html="slideshow[0].slide_text_line_2_mobile"></p>
                                <p class="line3" v-html="slideshow[0].slide_text_line_3_mobile"></p>
                            </div>
                        </div>
                    </template>
                </vueper-slide> -->
                <vueper-slide v-for="c in slideshow" :key="'aid' + c" class="below990">
                    <template #content>
                        <!-- <div class=" active tableHome Test" v-bind:style="{ 'background-image': 'url(' + b.tour_image + ')' }">
                        </div> -->
                        <img class="Btours" :src="c.mobile_image">
                        <div class="outerDiv">
                            <div class="innerDiv">
                                <h1 class="heading" :style="'color:' + c.slide_heading_color">{{c.slide_heading}}</h1>
                                <p class="line1" v-html="c.slide_text_line_1_mobile"></p>
                                <p class="line2" v-html="c.slide_text_line_2_mobile"></p>
                                <p class="lin3" v-html="c.slide_text_line_3_mobile"></p>
                            </div>
                        </div>
                    </template>
                </vueper-slide>
                <vueper-slide>
                    <template #content>
                        <div class=" active tableHome" v-bind:style="{ 'background-image': 'url(' + backImage + ')' }">
                        </div>
                    </template>
                </vueper-slide>
            </vueper-slides>
            <div id="myCarousel" class="carousel slide" data-ride="carousel" style="display:none">
            <ol class="carousel-indicators">
                <li data-target="#myCarousel" data-slide-to="0" class="active"></li>
                <li data-target="#myCarousel" data-slide-to="1"></li>
            </ol>

            <div class="carousel-inner">
                <div class="item tours">
                <div class="tableHome" v-bind:style="{ 'background-image': 'url(' + tournImage + ')' }">
                    <b-container>
                    <b-row class="above1200">
                        <b-col>
                        <b-row class="SponsorLogoText">
                            <b-col>
                            <div class="classTournBtn">
                                <button class="tournButtonMain">
                                    Tier 1
                                </button>
                            </div>
                            <h1 class="TournName">{{TourName}}</h1>
                            <h1 class="TournCourseName">{{course_name}}</h1>
                            <template v-if="bkImage == null">
                                <b-link :to="'/schedule/' " class="allNewsLink">
                                <button class="Allbuttons">
                                See Full Schedule
                                </button>
                                </b-link>
                            </template>
                            <template v-else>
                                <b-link :to="'/tournament/' + courseCode + '/' + Year " class="allNewsLink">
                                <button class="Allbuttons">
                                See Tournament Feed
                                </button>
                                </b-link>
                            </template>
                            </b-col>
                        </b-row>
                        </b-col>
                        <b-col>

                        </b-col>
                    </b-row>
                    <b-row class="below1200">
                        <b-col lg="12">
                        <b-row class="SponsorLogoText">
                            <b-col>
                            <div class="dates">
                                <h2 class="TournDates">{{tournDates}}</h2>
                            </div>
                            <h1 class="TournName">{{TourName}}</h1>
                            <h1 class="TournCourseName">{{course_name}}</h1>
                            <template v-if="bkImage == null">
                                <b-link :to="'/schedule/'" class="allNewsLink">
                                <button class="Allbuttons">
                                See Full Schedule
                                </button>
                                </b-link>
                            </template>
                            <template v-else>
                                <b-link :to="'/tournament/' + courseCode + '/' + Year" class="allNewsLink">
                                <button class="Allbuttons">
                                See Tournament Feed
                                </button>
                                </b-link>
                            </template>
                            </b-col>
                        </b-row>
                        </b-col>
                        <b-col lg="12">
                        </b-col>
                    </b-row>
                    </b-container>
                    <b-row class="imagefilesPos">
                    <b-col class="imageSize" lg="" sm="6" v-for="(image, index) in imagefiles" :key="'d' + index" v-show="image.ad_lcc == 'N' && image.ad_file != ''" >
                        <b-link :href="image.ad_link" :title="image.ad_desc" target="_blank">
                        <div class="imagefileImage" v-bind:style="{ 'background-image': 'url(' + image.ad_file + ')' }"></div>
                        </b-link>
                    </b-col>
                    </b-row>
                </div>
                </div>
            </div>
            </div> 
        </div>

  </div>
</template> 

<script>
import apiCall from "@/services/api.js";
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
export default {
  name: "Just Slides",
  components: {
    VueperSlides, VueperSlide
  },
  props:[
    'frontImage',
    'backImage'
  ],
  data() {
    return {
        slideshow: [],
        tournImage: '',
        TourName: '',
        course_name:'',
        bkImage: '',
        tournDates: '',
        courseCode: '',
        Year: '',
        imagefiles: ''
    }
  },
  created() {
    const json = "wp/v2/slideshow?randomadd=" +
            new Date().getTime();
    apiCall
      .wpInfo(json)
      .then(({ data }) => {
        this.slideshow = data[0].acf.slideshow;
        console.log( "this.slideshow")
        console.log( this.slideshow)
        // console.clear()
      })
      .catch((error) => {
        console.log(error);
        throw error;
      });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
::v-deep .vueperslide {
    white-space: normal;
    background-size: cover;
    flex-shrink: 0;
    display: block;
    width: 100%;
    position: relative;
    will-change: transform;
}
h1.heading {
    text-transform: uppercase;
    font-size: 70px;
    /* font-weight: bold; */
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
}
p.line1 {
    /* text-transform: uppercase; */
    font-size: 40px;
}
p.line2 {
    /* text-transform: uppercase; */
    font-size: 20px;
}
p.line3 {
    /* text-transform: uppercase; */
    font-size: 10px;
}
.innerDiv {
    position: absolute;
    top: 30%;
    color: #fff;
    z-index: 999;
    /* height: 200px; */
    width: 100%;
    background-color: rgba(8, 28, 63, 0.5);
    text-align: center;
    padding-top: 30px;
    padding-bottom: 30px;
}
::v-deep .vueperslides__parallax-wrapper {
  height: 100%!important;
}
.tableHome {
  padding-bottom: 2%;
  background-repeat: no-repeat;
  /* height: 700px; */
  height: 100%!important;
  background-size: cover;
  /* margin-bottom: 4em; */
  background-position: center;
}
.Btours {
    width: 100%;
}
@media only screen and (min-width: 991px) {
    ::v-deep .below990 {
        display: none;
    }
}
@media only screen and (max-width: 990px) {
    ::v-deep .above990 {
        display: none;
    }
    ::v-deep .vueperslides__parallax-wrapper {
        height: 500px!important;
    }
}
@media only screen and (max-width: 1366px) {
    h1.heading {
        text-transform: uppercase;
        font-size: 50px;
        /* font-weight: bold; */
        font-family: "brown-pro-condensed", sans-serif;
        font-weight: 800;
        font-style: normal;
    }
    p.line1 {
        /* text-transform: uppercase; */
        font-size: 20px;
    }
    p.line2 {
        /* text-transform: uppercase; */
        font-size: 15px;
    }
    p.line3 {
        /* text-transform: uppercase; */
        font-size: 10px;
    }
}
@media only screen and (max-width: 510px) {
    ::v-deep .vueperslides__parallax-wrapper {
        /* height: 100%!important; */
        height: 425px!important;
    }
    p.line2 {
        display: none;
    }
    p.lin3 {
        display: none;
    }
}
@media only screen and (max-width: 375px) {
    ::v-deep .vueperslides__parallax-wrapper {
        /* height: 100%!important; */
        height: 375px!important;
    }
    p.line2 {
        display: none;
    }
    p.lin3 {
        display: none;
    }
    .innerDiv {
        position: absolute;
        top: 15%;
        color: #fff;
        z-index: 999;
        /* height: 200px; */
        width: 100%;
        background-color: rgba(8, 28, 63, 0.5);
        text-align: center;
        padding-top: 30px;
        padding-bottom: 30px;
    }
}
</style>
